/**
 * Toggles between static (reduced motion) and animated versions.
 * Finds the correct animated source by matching media queries against the current viewport.
 */
const togglePlayback = (event) => {
  const container = event.target.closest("#js-gif-player")
  if (!container) return

  const picture = container.querySelector("picture")
  const img = container.querySelector("img")
  if (!picture || !img) return

  const browserFineWithMotion =
    window.matchMedia(`(prefers-reduced-motion: reduce)`).matches !== true
  if (browserFineWithMotion) return

  const sources = Array.from(picture.querySelectorAll("source"))

  // Find all animated sources (those without prefers-reduced-motion)
  const animatedSources = sources.filter(
    (s) => !s.getAttribute("media")?.includes("prefers-reduced-motion"),
  )

  // Find the animated source that matches the current viewport media query
  const activeAnimationSource = animatedSources.find((s) => {
    const media = s.getAttribute("media")
    return !media || window.matchMedia(media).matches
  })

  if (!activeAnimationSource) return

  if (container.classList.contains("is-playing")) {
    // Restore original reduced motion state
    sources.forEach((source) => {
      if (source.dataset.originalSrcset) source.srcset = source.dataset.originalSrcset
    })
    img.src = container.dataset.originalImgSrc || img.src
    container.classList.remove("is-playing")
  } else {
    // Switch to animation state
    container.dataset.originalImgSrc = img.src
    const animationUrl = activeAnimationSource.srcset

    // Update all sources to point to the correct animated URL for this viewport.
    // We update ALL sources to prevent responsive logic from swapping back to static.
    sources.forEach((source) => {
      source.dataset.originalSrcset = source.srcset
      source.srcset = animationUrl
    })
    img.src = animationUrl
    container.classList.add("is-playing")
  }
}

export const initialiseGifClickToPlay = () => {
  if (window.gifPlayerInitialized) return
  document.addEventListener("click", togglePlayback)
  window.gifPlayerInitialized = true
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initialiseGifClickToPlay)
} else {
  initialiseGifClickToPlay()
}
